import { useState, useEffect, useRef } from "react";
import { getCities, getJobTitles } from "../../../service/api";
import Typed from "typed.js";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

function Banner() {
  const navigate = useNavigate();
  const suggestionRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  // input states (UI only)
  const [jobTitleInput, setJobTitleInput] = useState("");
  const [cityInput, setCityInput] = useState(null);

  // applied states (used on search)
  const [jobTitle, setJobTitle] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const typedEl = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedEl.current, {
      strings: [
        "Hire verified talent - fast, flexible, and reliable.",
        // "Flexible Hourly Jobs, On Your Time",
        // "Thousands Finding Hourly Work Daily",
        // "Easy Hourly Jobs for Flexible",
      ],
      typeSpeed: 50,
      backSpeed: 30,
      backDelay: 1500,
      loop: true,
    });

    // ✅ Cleanup on unmount
    return () => {
      typed.destroy();
    };
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await getCities();
        if (res.status === 200 && res.data && res.data.data) {
          const formatted = res.data.data.map((city) => ({
            value: city,
            label: city,
          }));
          setOptions(formatted);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCities();
  }, []);

  const loadSuggestions = async (text) => {
    if (!text) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const res = await getJobTitles(text);
      if (res.status === 200 && res.data?.data) {
        setSuggestions(res.data.data);
        setShowSuggestions(true);
      }
    } catch (e) {
      console.error("Suggestion error:", e);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (suggestionRef.current && !suggestionRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="bannerSection employerbannerSec wow animate__fadeIn">
      <div className="bannersearch">
        <div className="">
          <div className="site-width">
            <div className="row justify-content-between align-item-center">
              <div className="col-md-7">
                <div className="bannerSerachContainer">
                  <div className="banenrTitle">
                    <h3 className="wow animate__fadeInUp" data-wow-delay="0">
                      <span ref={typedEl}></span>
                    </h3>
                    <p className="wow animate__fadeInUp" data-wow-delay="0.2s">
                      Connect with verified professionals ready to work by the
                      hour. Hire fast, stay flexible, and manage your staff
                      effortlessly.
                    </p>
                  </div>
                  <div className="searchBar wow animate__zoomIn">
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();

                        setJobTitle(jobTitleInput);
                        setSelectedCity(cityInput);
                        setShowSuggestions(false);

                        navigate(
                          `/employer/candidate-list?jobProfile=${encodeURIComponent(
                            jobTitleInput
                          )}&city=${encodeURIComponent(cityInput || "")}`
                        );
                      }}
                    >
                      <div className="row-group-search">
                        <div
                          className="form-group form-group-1"
                          ref={suggestionRef}
                        >
                          <i className="fa-solid fa-magnifying-glass"></i>
                          <input
                            type="text"
                            className="input-filter-search"
                            placeholder="Job title, key words..."
                            value={jobTitleInput}
                            onChange={(e) => {
                              setJobTitleInput(e.target.value);
                              loadSuggestions(e.target.value);
                              setShowSuggestions(true);
                            }}
                          />

                          {showSuggestions && suggestions.length > 0 && (
                            <div
                              className="suggestion-box"
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ddd",
                                zIndex: 1000,
                                borderRadius: "6px",
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {suggestions.map((item, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "8px 10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setJobTitleInput(item);
                                    setShowSuggestions(false);
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {item}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="form-group form-group-2">
                          <i className="fa-solid fa-location-crosshairs"></i>
                          <Select
                            id="select-location"
                            name="city"
                            className="select-location"
                            options={options}
                            isLoading={loading}
                            isSearchable
                            placeholder="Search Location..."
                            onChange={(opt) =>
                              setCityInput(opt ? opt.value : null)
                            }
                            value={
                              options.find((opt) => opt.value === cityInput) ||
                              null
                            }
                          />
                        </div>
                        <div className="form-group-4">
                          <button type="submit" className="searchbtn">
                            Search
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="bannerEmpimg">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/slider/employer-img.png`}
                    alt="img"
                    className="employerbnrimg"
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/slider/employer-img-bg.png`}
                    alt="img"
                    className="employerbnrimgbg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
